/**
 * 报文调试 API（辅助工具 → 报文调试）
 * 含：JSON 工具箱（格式化/校验/JSONPath 提取/Schema 生成）、文本/JSON Diff、
 * 时间戳互转、cron 表达式解析（临时 Mock 服务由系统既有 Mock 服务承担）
 */
import { post } from '@/utils/request'
import type {
  CronResult, DiffResult, JsonAction, JsonToolboxResult, TimezoneName, TimestampResult,
} from '@/types'

/** JSON 工具箱（格式化/校验/JSONPath/Schema 生成） */
export const jsonToolbox = (data: { action: JsonAction; content: string; indent?: number; jsonpath?: string }) =>
  post<JsonToolboxResult>('/payload-debug/json', data)

/** 文本/JSON Diff（预期 vs 实际报文对比） */
export const diffPayload = (data: { left: string; right: string; mode: 'text' | 'json' }) =>
  post<DiffResult>('/payload-debug/diff', data)

/** 时间戳互转（秒/毫秒自动识别，多时区） */
export const timestampConvert = (data: { action: 'ts_to_date' | 'date_to_ts'; value: string; zone: TimezoneName }) =>
  post<TimestampResult>('/payload-debug/timestamp', data)

/** cron 表达式解析（字段明细 + 中文描述 + 未来执行时间） */
export const cronAnalyze = (data: { expr: string; next_count?: number }) =>
  post<CronResult>('/payload-debug/cron', data)

/** cron 表达式生成（中文文字描述 → 表达式，附解析结果） */
export const cronGenerate = (data: { text: string }) =>
  post<CronResult>('/payload-debug/cron/generate', data)

/** 结果文本下载为本地文件 */
export const downloadTextFile = (filename: string, content: string) => {
  const blob = new Blob([content], { type: 'text/plain;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}
